import { LazyErrorBoundary, LazyLoadingFallback, LazyLottie } from '@/lib/lazy-components'
import AgentLoader from '@/styles/animations/agent-loader.json'
import type { LottieComponentProps } from 'lottie-light-react'
import React from 'react'

export const AgentAnimation = (props: Omit<LottieComponentProps, 'animationData' | 'ref'>) => (
  <LazyErrorBoundary>
    <React.Suspense fallback={<LazyLoadingFallback className='h-8 w-8' />}>
      <LazyLottie animationData={AgentLoader} {...props} />
    </React.Suspense>
  </LazyErrorBoundary>
)
